<template>
  <div class="fullBox">
    <div class="fullBox">
      <router-view class="fullBox"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.minwidth {
  // min-width: 1160px;
}
</style>
